import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { LotService } from 'src/app/core/services/data/lot.service';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { LotList } from 'src/app/shared/entities/LotList';
import { UpdateUserSettings } from 'src/app/shared/entities/UpdateUserSettings';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IParcsGetLotConfigurationResponse } from 'src/app/shared/code/interfaces/parcs-interfaces';

@Component({
  selector: 'app-lot-select',
  templateUrl: './lot-select.component.html',
  styleUrl: './lot-select.component.scss',
  providers: [ParcsDataService],
})
export class LotSelectComponent implements OnInit {
  lotList: LotList[] = [];
  concatenatedLotList: string[] = [];
  findLotForm: FormGroup;
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  newDefaultLotNumber: string = '';
  newDefaultLotName: string = '';
  clearedToSaveNewLot: boolean = false;
  lotParcsConfiguration: IParcsGetLotConfigurationResponse = {} as IParcsGetLotConfigurationResponse;

  public _appGeneralState = inject(AppGeneralStateService);
  private _lotService = inject(LotService);
  private _parcsDataService = inject(ParcsDataService);
  private _destroyRefService = inject(DestroyRef);
  private _dialogRef = inject(MatDialogRef<LotSelectComponent>);

  constructor() {
    this.initFindLotForm();
    this.lotList = this._appGeneralState.UsersLotList;

    this.lotList.forEach(async (lot) => {
      const newLotItem = lot.lotId + ' - ' + lot.lotName;
      this.concatenatedLotList.push(newLotItem);
    });
  }

  ngOnInit(): void {
    this.filteredOptions = this.findLotForm.get('lotFind').valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || '')),
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    const newLotSelected = this.concatenatedLotList.filter((option) => option.toLowerCase().includes(filterValue));

    return newLotSelected;
  }

  onSetNewLot(): void {
    const lotInfo = this.findLotForm.get('lotFind').value;
    const index = lotInfo.indexOf(' ', 0);
    const lotNumber: string = lotInfo.substring(0, index);
    let lotName: string = lotInfo.substring(index + 1, lotInfo.length);

    lotName = lotName.substring(2, lotName.length);

    this.newDefaultLotNumber = lotNumber;
    this.newDefaultLotName = lotName;

    this._appGeneralState.currentLotNumber = lotNumber;
    this._appGeneralState.currentLotName = lotName;

    this.setDefaultLotForUser(this.newDefaultLotNumber);

    this._appGeneralState.lotNumberSignal.set(lotNumber);
    this._appGeneralState.lotNumberNameSignal.set(`${lotNumber} - ${lotName}`);

    this._appGeneralState.PublishLotNumberName(lotNumber, lotName);

    this._dialogRef.close({
      lotNumber: this.newDefaultLotNumber,
      lotName: this.newDefaultLotName,
      success: true,
    });

    this._appGeneralState.getParcsLotConfigurationData(lotNumber);
  }

  // setParcsStatusOnLotChange(lotNumber: string): void {
  //   this.getParcsLotConfigurationData(lotNumber);
  // }

  // Determine if this lot has a parcs
  // getParcsLotConfigurationData(lotNumber: string) {
  //   this._parcsDataService
  //     .getParcsLotConfigurationByLotNumber(lotNumber)
  //     .pipe(takeUntilDestroyed(this._destroyRefService))
  //     .subscribe({
  //       next: (res) => {
  //         this.lotParcsConfiguration = res;

  //         if (this.lotParcsConfiguration.lotNumber == lotNumber) {
  //           this._appGeneralState.currentLotHasParcs = true;
  //         } else this._appGeneralState.currentLotHasParcs = false;
  //       },
  //       error: (err: any) => {
  //         this._appGeneralState.currentLotHasParcs = false; // no configuration found,
  //       },
  //       complete: () => {
  //         this._dialogRef.close({
  //           lotNumber: this.newDefaultLotNumber,
  //           lotName: this.newDefaultLotName,
  //           success: true,
  //         });
  //       },
  //     });
  // }

  initFindLotForm(): void {
    let searchString: string;
    this.findLotForm = new FormGroup({
      lotFind: new FormControl('', [Validators.required]),
    });

    this.findLotForm.controls['lotFind'].valueChanges.subscribe((value) => {
      this.clearedToSaveNewLot = this.concatenatedLotList.indexOf(value.toUpperCase()) > -1;
    });
  }

  setDefaultLotForUser(lotNumber: string): void {
    let userSettings: UpdateUserSettings = new UpdateUserSettings();

    userSettings.userId = this._appGeneralState.userId;
    userSettings.lotNumber = lotNumber;

    this._lotService.setCurrentDefaultLotForUser(userSettings);
    //this.getAmanoOneParcsLotConfigurationData(lotNumber);
  }

  // HTTP Data Methods
}
